<template>
  <div
    class="mx-6 sm:m-auto p-5 bg-brand-strong-bg-overlay-80 backdrop-blur-3xl overflow-y-auto max-w-none sm:max-w-[453px] w-full rounded-[35px] h-auto max-h-[calc(100vh_-_5em)] gap-30u flex flex-col"
    :class="$attrs.class"
    data-testid="auth-modal"
  >
    <div class="flex flex-row-reverse justify-between gap-3">
      <button
        class="p-2 w-auto h-auto bg-brand-bgdivider-20 text-basics-primary border-0 rounded-full"
        data-dismiss="modal"
        aria-label="Close"
        @click="close"
      >
        <Icon icon="mdi:close" class="text-2xl" />
      </button>

      <button
        v-if="showBackButton"
        class="p-2 w-auto h-auto bg-brand-bgdivider-20 text-basics-primary border-0 rounded-full"
        aria-label="Back"
        @click="goBack"
      >
        <Icon icon="mdi:arrow-left" class="text-2xl" />
      </button>
    </div>

    <header class="flex flex-col items-center justify-center gap-4">
      <AvatarRoot
        v-if="channelStore.channel"
        class="bg-brand-light-bg-overlay-50 inline-flex size-60u select-none items-center justify-center overflow-hidden rounded-lg align-middle"
      >
        <AvatarImage
          v-if="channelStore.channel.logo"
          class="h-full w-full rounded-[inherit] object-cover"
          :src="channelStore.channel.logo"
          :alt="channelStore.channelSlug"
        />
        <AvatarFallback
          class="text-basics-primary leading-1 flex h-full w-full items-center justify-center bg-brand-primary text-xs font-medium"
          :delay-ms="600"
        >
          {{ channelStore.channelSlug?.slice(0, 2) ?? ".." }}
        </AvatarFallback>
      </AvatarRoot>

      <div class="space-y-2.5 text-center">
        <h3
          class="text-xl font-bold font-sans text-basics-primary leading-none"
        >
          {{ title }}
        </h3>
        <p
          v-if="caption"
          class="text-sm font-normal font-sans text-[#B7B7B7] leading-none"
        >
          {{ caption }}
        </p>
      </div>
    </header>

    <slot :is-open="isOpen" />
  </div>
</template>

<script setup lang="ts">
import { useChannelStore } from "@/stores/channel.store";
import { Icon } from "@iconify/vue";
import { AvatarFallback, AvatarImage, AvatarRoot } from "reka-ui";

const emit = defineEmits<{
  close: [];
  goBack: [];
}>();

defineProps<{
  title: string;
  caption?: string;
  showBackButton: boolean;
  isOpen: boolean;
  isReferralInvitation?: boolean;
}>();

const channelStore = useChannelStore();

const close = () => emit("close");
const goBack = () => emit("goBack");
</script>
